import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const CarouselPlaceholder = (props) => {
    let defaultClasses = 'il-pre-carousel-thumb w-100 object-fit location-thumb';
    return (
        <Fragment>
            {!!props.loadedThumbnail && (
                <img
                    className={`${defaultClasses}`}
                    width={props.loadedThumbnail.width}
                    height={props.loadedThumbnail.height}
                    src={props.loadedThumbnail.src}
                    alt={props.title}
                />
            )}

            {!props.loadedThumbnail && (
                <picture>
                    <source
                        type="image/webp"
                        srcSet={props.img.webp}
                        sizes="1000px"
                    />
                    <source
                        type="image/jpeg"
                        srcSet={props.img.jpeg}
                        sizes="1000px"
                    />
                    <img
                        className={`${defaultClasses}`}
                        width={props.img.width}
                        height={props.img.height}
                        src={`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${props.img.width} ${props.img.height}'%3E%3C/svg%3E`}
                        alt={props.title}
                        data-src={props.img.src}
                    />

                </picture>
            )}
            {props.children}
        </Fragment>
    );
}

CarouselPlaceholder.propTypes = {
    // loadedThumbnail: PropTypes.object.isRequired,
    img: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    // gallery: PropTypes.array.isRequired,
}

export default CarouselPlaceholder;
